import type { ResourceConfig } from "../types";

export const responseExclusionConfig = {
  displayName: "响应时间排除",
  category: "response-exclusion",
  permissions: {
    "read:all": {
      label: "查看所有排除申请",
      description: "可以查看所有教练的排除申请",
    },
    "write:own": {
      label: "提交排除申请",
      description: "可以提交和取消自己的响应时间排除申请",
    },
    "approve:all": {
      label: "审批排除申请",
      description: "可以审批所有教练的排除申请",
    },
  },
} satisfies ResourceConfig;
